import useResizeObserver from '@react-hook/resize-observer';
import { RefObject, useCallback, useState } from 'react';

export function useHeight(ref: RefObject<HTMLElement | null>) {
  const [height, setHeight] = useState<number | undefined>(undefined);

  const onRef = useCallback(
    (node: HTMLDivElement | null) => {
      ref.current = node;
      const height = ref?.current?.getBoundingClientRect().height;
      if (ref.current && height && height > 0) {
        setHeight(height);
      }
    },
    [ref]
  );

  useResizeObserver(ref?.current, (entry) => {
    if (entry.contentRect.height) {
      setHeight(entry.contentRect.height);
    }
  });

  return { height, onRef };
}

export function useWidth(ref: RefObject<HTMLElement | null>) {
  const [width, setWidth] = useState<number | undefined>(undefined);

  const onRef = useCallback(
    (node: HTMLDivElement | null) => {
      ref.current = node;
      const width = ref?.current?.getBoundingClientRect().width;
      if (ref.current && width && width > 0) {
        setWidth(width);
      }
    },
    [ref]
  );

  useResizeObserver(ref?.current, (entry) => {
    if (entry.contentRect.width) {
      setWidth(entry.contentRect.width);
    }
  });

  return { width, onRef };
}

export function useMeasuredSize<T extends HTMLElement>(
  ref: RefObject<T | null>,
  defaults: {
    width?: number | (() => number | undefined);
    height?: number | (() => number | undefined);
  } = {}
) {
  const [width, setWidth] = useState<number | undefined>(defaults.width);
  const [height, setHeight] = useState<number | undefined>(defaults.height);

  const onRef = useCallback(
    (node: T | null) => {
      ref.current = node;

      const width = ref?.current?.getBoundingClientRect().width;
      if (ref.current && width && width > 0) {
        setWidth(width);
      }

      const height = ref?.current?.getBoundingClientRect().height;
      if (ref.current && height && height > 0) {
        setHeight(height);
      }
    },
    [ref]
  );

  useResizeObserver(ref?.current, (entry) => {
    if (entry.contentRect.width) {
      setWidth(entry.contentRect.width);
    }
    if (entry.contentRect.height) {
      setHeight(entry.contentRect.height);
    }
  });

  return { width, height, onRef };
}
